import API from '@/models/API';

export default class ViewCampaigns {
  constructor(item = {}) {}

  static get = (payload) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/campaigns${payload.query}`);

  static getCampaignSystemNotifications = () =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/campaigns/campaign-system-notifications`
    );

  static getCampaignTypes = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/campaigns/campaign-types`);

  static getTransactionTypes = () => API.get(`/common/campaigns/transaction-types`);

  static getClientCharacteristics = (typeId) =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/campaigns/campaign-client-characteristics?campaign-type-id=${typeId}`
    );

  static getConditions = (typeId) =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/campaigns/campaign-conditions?campaign-type-id=${typeId}`
    );

  static getCampaign = (id) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/campaigns/${id}`);

  static changeStatus = (data) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${data.campaign_id}/change-status`,
      data.body
    );

  static getCampaignStatuses = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/campaigns/statuses`);

  static getParticipants = (payload) =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${payload.id}/participants${payload.query}`
    );

  static getParticipant = (payload) =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${payload.campaign_id}/participants/${payload.participant_id}`
    );

  static getStore = (id) => API.get(`/companies/${localStorage.getItem('storeId')}/stores/${id}`);

  static refreshReward = (payload) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${payload.campaign_id}/participants/${payload.participant_id}/refresh-reward`
    );

  static updateNotificationText = (id, body) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/campaigns/${id}/notification`, body);

  static saveRewardSms = (payload) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${payload.campaign_id}/campaign-reward/${payload.campaign_reward_id}`,
      payload.body
    );

  static updateCampaignTypeOptions = (payload) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${payload.campaign_id}/campaign_type `,
      payload.body
    );

  static updateCampaignSettings = (payload) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${payload.campaign_id}/settings `,
      payload.body
    );

  static updateBilling = (id, billable) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${id}/notifications/billable`,
      { billable }
    );
  static resetRewards = (payload) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${payload.campaign_id}/campaign-participant-rewards/reset`
    );

  static addRemainingRewards = (payload) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${payload.campaign_id}/campaign-participant-rewards/attach-all-remaining`
    );

  static assignRewardToParticipant = (payload) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${payload.campaign_id}/campaign-participant-rewards/attach`,
      payload
    );

  static detachRewardFromParticipant = (id, body) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${id}/campaign-participant-rewards/detach`,
      body
    );

  static getCampaignRewards = (payload) =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/campaigns/${payload.campaign_id}/campaign-participant-rewards`
    );
}
